import Mutations from '../../odata/mutations';

export default { ...new Mutations('regulatorySymbol'), ...new Mutations('regulatorySymbols') };
